import(/* webpackMode: "eager" */ "/app/app/page.tsx")